import React, { useRef, useState, useEffect } from 'react';
import {
  AppShell,
  Navbar,
  Paper,
  Group,
  Title,
  ScrollArea,
  Aside,
  Modal,
  Divider,
  Space,
  ActionIcon,
  Text,
  Stack,
  Input,
  Box,
  Center,
  MediaQuery,
  useMantineTheme,
  Button,
  Image,
  Checkbox,
  NumberInput,
  Loader,
} from '@mantine/core';
import dayjs from 'dayjs';
import { groupBy } from 'lodash';
import { showNotification } from '@mantine/notifications';
import { DatePicker } from '@mantine/dates';
import { CircleX, Calendar, Edit, EditOff } from 'tabler-icons-react';
import Keyboard from 'react-simple-keyboard';
import { sendRequest } from '../../services/services';
import LandingLayout from '../../components/LandingLayout';
import VerifyRefund from './VerifyRefund';
import Profile from '../Profile/profile';
import cashIcon from '../../image/cash.png';
import cardIcon from '../../image/card.png';

const Refund = () => {
  const theme = useMantineTheme();
  const [inputs, setInputs] = useState({});
  const [confirmRefund, setConfirmRefund] = useState(false);
  const [verifyRefund, setVerifyRefund] = useState(false);
  const [layoutName, setLayoutName] = useState('default');
  const [inputName, setInputName] = useState('default');
  const [ticketData, setTicketData] = useState({});
  const [passIdData, setPassIdData] = useState();
  const [invoiceData, setInvoiceData] = useState();
  const [, setOriginalData] = useState();
  const [selectedVas, setSelectedVas] = useState([]);
  const [refundAmount, setRefundAmount] = useState(0);
  const [dateValue, setDateValue] = useState();
  const [checked, setChecked] = useState(false);
  const keyboard = useRef();
  const [, setDataChange] = useState([]);
  const [profileData, setProfileData] = useState({});
  const [refundInfo, setRefundInfo] = useState({});
  const [isMobileEdit, setIsMobileEdit] = useState(false);
  const [checkId, setCheckId] = useState();
  const [touched, setTouched] = useState(false);
  const [isLoading, setIsLoading] = useState(false); // Add isLoading state

  useEffect(() => {
    if (invoiceData?.reservations?.pass_id) {
      sendRequest(`cashier/reservations-by-pass-id/${invoiceData?.reservations?.pass_id}`, 'get')
        .then((res) => {
          if (res?.code === 20) {
            setTicketData(res?.data || []);
          }
        })
        .catch((err) => {
          if (err?.response?.data?.code) {
            showNotification({
              title: <Text weight={500}>{err?.response?.data?.msg}</Text>,
              icon: <CircleX size={16} />,
            });
          }
        })
        .finally(() => {
          setIsLoading(false); // Set isLoading to false after fetching data
        });
    }
  }, [invoiceData?.reservations?.pass_id, passIdData]);

  const onChangeAll = (inputsValue) => {
    /**
     * Here we spread the inputs into a new object
     * If we modify the same object, react will not trigger a re-render
     */
    setInputs({ ...inputsValue });
    setTouched(true);
  };

  const handleShift = () => {
    const newLayoutName = layoutName === 'default' ? 'shift' : 'default';
    setLayoutName(newLayoutName);
  };

  const onChangeInput = (event) => {
    const inputVal = event.target.value;

    setInputs({
      ...inputs,
      [inputName]: inputVal,
    });
    keyboard.current.setInput(inputVal);
    setTouched(true);
  };

  const getInputValue = (inputNameValue) => inputs[inputNameValue] || '';

  const date1 = dayjs(
    ticketData?.result?.tickets?.entry_time
      ? ticketData?.result?.tickets?.entry_time
      : ticketData?.result?.start_time,
  );
  const date2 = dayjs(
    ticketData?.result?.tickets?.exit_time
      ? ticketData?.result?.tickets?.exit_time
      : ticketData?.result?.end_time,
  );

  const TotalSeconds = date2.diff(date1, 'minutes');
  const hours = Math.ceil(TotalSeconds / 60);
  const startDate = dayjs(
    ticketData?.result?.tickets?.entry_time
      ? ticketData?.result?.tickets?.entry_time
      : ticketData?.result?.start_time,
  )
    .format('DD-MM-YYYY HH:mm')
    .slice(0, -5);
  const startTime = dayjs(
    ticketData?.result?.tickets?.entry_time
      ? ticketData?.result?.tickets?.entry_time
      : ticketData?.result?.start_time,
  )
    .format('DD-MM-YYYY HH:mm')
    .slice(10);

  const endDate = dayjs(
    ticketData?.result?.tickets?.exit_time
      ? ticketData?.result?.tickets?.exit_time
      : ticketData?.result?.end_time,
  )
    .format('DD-MM-YYYY HH:mm')
    .slice(0, -5);
  const endTime = dayjs(
    ticketData?.result?.tickets?.exit_time
      ? ticketData?.result?.tickets?.exit_time
      : ticketData?.result?.end_time,
  )
    .format('DD-MM-YYYY HH:mm')
    .slice(10);

  const firstDate = dayjs(dateValue).format('DD/MM/YYYY');

  const invoiceDates = invoiceData?.payment_transactions?.map((transaction) =>
    dayjs(transaction?.updated_at).format('DD/MM/YYYY'),
  );

  const invoiceId = getInputValue('invoiceNumber');
  const searchInvoice = () => {
    setIsLoading(true);
    sendRequest(`cashier/invoice/${invoiceId}`, 'get')
      .then((res) => {
        if (res?.code === 20) {
          setInvoiceData(res?.data);
          setOriginalData(
            res?.data?.invoice_items?.map((d) => {
              const updatedItem = d; // Create a new object with the same properties
              updatedItem.initialUnit = d.unit; // Assign the initialUnit property on the new object
              return updatedItem; // Return the updated object
            }),
          );
          if (!invoiceDates.includes(firstDate)) {
            showNotification({
              title: <Text weight={500}>Invalid Ticket!</Text>,
              icon: <CircleX size={16} />,
            });
          } else {
            setPassIdData(res?.data?.reservations?.pass_id);
          }
        } else if (invoiceData?.id && !invoiceDates.includes(firstDate)) {
          showNotification({
            title: <Text weight={500}>Invalid Ticket!</Text>,
            icon: <CircleX size={16} />,
          });
        } else {
          showNotification({
            title: <Text weight={500}>Invalid Ticket!</Text>,
            icon: <CircleX size={16} />,
          });
        }
      })
      .catch((err) => {
        if (err?.response?.data?.code) {
          showNotification({
            title: <Text weight={500}>{err?.response?.data?.msg}</Text>,
            icon: <CircleX size={16} />,
          });
        }
      })
      .finally(() => {
        setIsLoading(false); // Set isLoading to false after fetching data
      });
  };

  const onKeyPress = (button) => {
    if (button === '{shift}' || button === '{lock}') handleShift();
    if (button === '{enter}') {
      searchInvoice();
    }
  };

  const conirmRefundModel = () => {
    setVerifyRefund(true);
    setConfirmRefund(false);
  };

  const fetchProfile = () => {
    sendRequest(`cashier/profile`, 'get').then((res) => {
      setProfileData(res?.data || []);
    });
  };

  useEffect(() => {
    fetchProfile();
    setTimeout(fetchProfile(), 2000);
  }, []);

  useEffect(() => {
    const siteId = `?site_id=${
      profileData?.user__site__assign?.filter((item) => item?.is_active)[0]?.sites?.id
    }`;

    sendRequest(`cashier/cashier-refund-info/${siteId}`, 'get').then((res) => {
      setRefundInfo(res?.data || []);
    });
  }, [profileData?.user__site__assign]);

  const mobileEdit = () => {
    setIsMobileEdit(!isMobileEdit);
  };

  const showError =
    touched &&
    ((inputs?.mobileNumber?.length ?? 0) < 7 || (inputs?.mobileNumber?.length ?? 0) > 12);

  const taxRate = 0.15; // 15% tax rate
  const refundAmountWithTax = refundAmount * (1 + taxRate);
  const taxAmount = refundAmountWithTax - refundAmount;

  const displayRefundMobile = () => {
    if (!isMobileEdit) {
      if (ticketData?.result?.guest_users === null) {
        return (
          <div>
            <Group>
              <Title order={5}>
                {!ticketData?.result?.customers?.country_code?.dial_code
                  ? '---'
                  : ticketData?.result?.customers?.country_code?.dial_code}
              </Title>
              <Title order={5}>
                {!ticketData?.result?.customers?.mobile
                  ? '---'
                  : ticketData?.result?.customers?.mobile}
              </Title>
            </Group>
          </div>
        );
      }

      return (
        <div>
          <Group>
            <Title order={5}>
              {!ticketData?.result?.guest_users?.country_code?.dial_code
                ? '---'
                : ticketData?.result?.guest_users?.country_code?.dial_code}
            </Title>
            <Title order={5}>
              {!ticketData?.result?.guest_users?.mobile
                ? '---'
                : ticketData?.result?.guest_users?.mobile}
            </Title>
          </Group>
        </div>
      );
    }

    return (
      <div>
        <Input.Wrapper required>
          <Input
            id="mobileNumber"
            defaultValue={invoiceData?.mobile}
            value={inputs?.mobileNumber}
            onFocus={() => setInputName('mobileNumber')}
            onChange={onChangeInput}
            maxLength={12}
            minLength={7}
            style={{ width: '110px' }}
          />
          {showError && (
            <Text fz="xs" color="red">
              Mobile Number min 7 and max 12
            </Text>
          )}
        </Input.Wrapper>
      </div>
    );
  };

  const RefundAmountModal = () => {
    const mobileNumber = isMobileEdit
      ? getInputValue('mobileNumber')
      : ticketData?.result?.customers?.mobile || ticketData?.result?.guest_users?.mobile;
    if (mobileNumber) {
      setConfirmRefund(true);
    } else {
      showNotification({
        title: <Text weight={500}>Mobile Number is Required</Text>,
        icon: <CircleX size={16} />,
      });
    }
  };

  const dialCodeCustomer = () => {
    let dialCode;

    if (isMobileEdit) {
      dialCode = 99;
    } else if (ticketData?.result?.guest_users?.country_code?.dial_code) {
      dialCode = ticketData.result.guest_users.country_code.dial_code;
    } else {
      dialCode = ticketData?.result?.customers?.country_code?.dial_code;
    }

    return dialCode;
  };

  return (
    <LandingLayout className="no-printme">
      <div>
        <AppShell
          style={{
            position: 'fixed',
            width: '1000px',
          }}
          styles={{
            main: {
              background:
                theme.colorScheme === 'dark' ? theme.colors.dark[8] : theme.colors.gray[0],
            },
          }}
          navbarOffsetBreakpoint="sm"
          asideOffsetBreakpoint="sm"
          navbar={
            <Navbar
              p="md"
              hiddenBreakpoint="sm"
              width={{ sm: 330, lg: 400 }}
              className="no-printme"
            >
              <div style={{ margin: '10px 0 8px 0px' }}>
                <div style={{ backgroundColor: '#D9D9D9' }}>
                  <Center py="xs">
                    <Title order={3}>Enter Invoice Number</Title>
                  </Center>
                  <Stack>
                    <Input
                      id="invoiceNumber"
                      value={getInputValue('invoiceNumber')}
                      onFocus={() => setInputName('invoiceNumber')}
                      placeholder="Invoice Number"
                      onChange={onChangeInput}
                      px="sm"
                    />
                    <DatePicker
                      placeholder="Pick date"
                      inputFormat="MM/DD/YYYY"
                      labelFormat="MM/YYYY"
                      value={dateValue}
                      defaultValue={new Date()}
                      onChange={setDateValue}
                      icon={<Calendar size={16} />}
                      px="sm"
                    />
                  </Stack>
                  <Space h="xl" />
                </div>
                <Box style={{ width: '300px' }}>
                  <Keyboard
                    keyboardRef={(r) => {
                      keyboard.current = r;
                    }}
                    inputName={inputName}
                    layoutName={layoutName}
                    onChangeAll={onChangeAll}
                    onKeyPress={onKeyPress}
                    maxLength={19}
                    theme="hg-theme-default hg-layout-default myTheme enable-button"
                    layout={{
                      default: ['1 2 3', '4 5 6', '7 8 9', '0 {bksp} {enter}'],
                      shift: ['1 2 3', '4 5 6', '7 8 9', '0 {bksp}'],
                    }}
                    display={{
                      '{bksp}': '←',
                      '{space}': ' ',
                      '{enter}': '✔',
                    }}
                  />
                </Box>
              </div>
            </Navbar>
          }
          aside={
            <MediaQuery smallerThan="sm" styles={{ display: 'none' }} className="no-printme">
              <Aside p="md" hiddenBreakpoint="sm" width={{ sm: 220, lg: 240 }}>
                <Profile />
              </Aside>
            </MediaQuery>
          }
        >
          <Box style={{ width: '470px', margin: '-25px 0 0 -38px' }} className="no-printme">
            {invoiceData?.id && invoiceDates.includes(firstDate) ? (
              <Paper shadow="lg" withBorder p="xl">
                <Stack>
                  <Group position="apart" style={{ marginBottom: '-20px' }}>
                    <Group>
                      <Stack>
                        <Center>
                          <Title size="sm" order={2}>
                            Entry
                          </Title>
                        </Center>
                        <Center style={{ marginBottom: '-18px' }}>
                          <Text size="sm" weight={500}>
                            {startDate}
                          </Text>
                        </Center>
                        <Center>
                          <Text size="sm" weight={500}>
                            {startTime}
                          </Text>
                        </Center>
                      </Stack>
                    </Group>
                    <ActionIcon
                      color="dark"
                      size="xl"
                      radius="xl"
                      variant="default"
                      sx={{
                        borderColor: 'black',
                        width: '80px',
                        height: '80px',
                        borderRadius: '50px',
                      }}
                    >
                      <Text weight={900} size="lg">
                        {hours === 0 ? 1 : hours} hrs
                      </Text>
                    </ActionIcon>
                    <Group>
                      <Stack>
                        <Center>
                          <Title size="sm" order={2}>
                            Exit
                          </Title>
                        </Center>
                        <Center style={{ marginBottom: '-18px' }}>
                          <Text size="sm" weight={500}>
                            {endDate}
                          </Text>
                        </Center>
                        <Center>
                          <Text size="sm" weight={500}>
                            {endTime}
                          </Text>
                        </Center>
                      </Stack>
                    </Group>
                  </Group>
                  <Space h="xs" />
                  <Group position="apart">
                    <Title size="sx" order={2}>
                      Description
                    </Title>
                    <Title size="sx" order={2}>
                      Unit Cost
                    </Title>
                    <Title size="sx" order={2}>
                      Quantity
                    </Title>
                    <Title size="sx" order={2}>
                      Amount
                    </Title>
                  </Group>
                  <ScrollArea style={{ height: 90 }} offsetScrollbars scrollbarSize={2}>
                    <Group position="apart">
                      <Stack>
                        {invoiceData?.invoice_items?.map((item) => (
                          <Checkbox
                            size="xs"
                            label={
                              <Center>
                                <Text size="sm" weight={500} color="#817E7E">
                                  {item?.invoice_item_list?.name || item?.invoice_item_list}
                                </Text>
                              </Center>
                            }
                            onChange={(e) => {
                              setChecked(e.currentTarget.checked);
                              setCheckId(item?.id);
                            }}
                            value={selectedVas}
                          />
                        ))}
                      </Stack>

                      <Stack>
                        {invoiceData?.invoice_items.map((item) => (
                          <Text size="sm" weight={500} color="#817E7E">
                            {!item?.unit_price
                              ? 0
                              : item?.unit_price.toLocaleString('en-US', {
                                  minimumFractionDigits: 2,
                                  maximumFractionDigits: 2,
                                })}
                          </Text>
                        ))}
                      </Stack>

                      <Space w="md" />
                      <Stack>
                        {invoiceData?.invoice_items.map((item, index) =>
                          checkId === item?.id && checked ? (
                            <NumberInput
                              defaultValue={item?.unit}
                              style={{ width: '60px' }}
                              type="number"
                              min={0}
                              max={item?.initialUnit}
                              size="xs"
                              onChange={(e) => {
                                if (index !== -1) {
                                  invoiceData.invoice_items[index] = {
                                    ...item,
                                    unit: e,
                                    amount: (item?.unit_price ?? 0) * e,
                                  };

                                  setRefundAmount(
                                    (previousState) =>
                                      previousState +
                                      ((item?.amount ?? 0) - (item?.unit_price ?? 0) * e),
                                  );

                                  setDataChange(invoiceData);

                                  const groupedVas = groupBy(selectedVas, 'id');
                                  const existingItemIndex = groupedVas[item.id]?.[0]?.index;

                                  if (existingItemIndex !== undefined) {
                                    selectedVas[existingItemIndex] = {
                                      id: parseInt(item.id, 10),
                                      qty: e,
                                      index: existingItemIndex,
                                    };
                                  } else {
                                    selectedVas.push({
                                      id: parseInt(item.id, 10),
                                      qty: e,
                                      index: selectedVas.length,
                                    });
                                  }
                                  setSelectedVas([...selectedVas]);
                                }
                              }}
                            />
                          ) : (
                            <Text size="sm" weight={500} color="#817E7E">
                              {item?.unit}
                            </Text>
                          ),
                        )}
                      </Stack>

                      <Stack>
                        {invoiceData?.invoice_items.map((item) => (
                          <Text size="sm" weight={500} color="#817E7E">
                            {item?.amount.toLocaleString('en-US', {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })}{' '}
                            SAR
                          </Text>
                        ))}
                      </Stack>
                    </Group>

                    <Space h="xs" />
                    <Group position="apart" style={{ marginBottom: 0.5, marginTop: 0.5 }}>
                      {ticketData?.result?.enforcements.map((em) => (
                        <Text size="sm" weight={500} color="#817E7E">
                          {em?.name}
                        </Text>
                      ))}

                      {ticketData?.result?.enforcements.map((em) => (
                        <Text size="sm" weight={500} color="#817E7E">
                          {em?.amount}
                        </Text>
                      ))}

                      {ticketData?.result?.enforcements.map((em) => (
                        <Text size="sm" weight={500} color="#817E7E">
                          {em ? 1 : 0}
                        </Text>
                      ))}

                      {ticketData?.result?.enforcements.map((em) => (
                        <Text size="sm" weight={500} color="#817E7E">
                          {em?.amount.toLocaleString('en-US', {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          })}{' '}
                          SAR
                        </Text>
                      ))}
                    </Group>
                  </ScrollArea>

                  <Divider my="sm" />
                  <Group position="apart">
                    <Text size="sm" weight={500} color="#817E7E">
                      Sub total
                    </Text>
                    <Space w="xl" />
                    <Text size="sm" weight={500} color="#817E7E">
                      {Number((invoiceData?.total_amount || 0) - refundAmount).toLocaleString(
                        'en-US',
                        {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        },
                      )}{' '}
                      SAR
                    </Text>
                  </Group>

                  <Group position="apart">
                    <Text size="sm" weight={500} color="#817E7E">
                      Tax ( 15% )
                    </Text>
                    <Space w="xl" />
                    <Text size="sm" weight={500} color="#817E7E">
                      {Number((invoiceData?.tax || 0) - (taxAmount || 0)).toLocaleString('en-US', {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      })}
                    </Text>
                  </Group>
                </Stack>
                <Space h="xs" />

                <Divider size="sm" />
                <Group position="apart" style={{ marginBottom: 5, marginTop: 5 }}>
                  <Title size="sm" order={1}>
                    Total
                  </Title>
                  <Title size="sm" order={1}>
                    {Number(
                      (invoiceData?.total_amount || 0) +
                        (invoiceData?.tax || 0) -
                        (refundAmountWithTax || 0),
                    ).toLocaleString('en-US', {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })}
                  </Title>
                  <Title size="sm" order={1}>
                    SAR
                  </Title>
                </Group>
                <Divider size="sm" />

                <Stack>
                  <Title order={5}>Customer Info</Title>
                  <Group spacing="xs">
                    {ticketData?.result?.guest_users === null ? (
                      <Title order={5}>
                        Name:{' '}
                        {!ticketData?.result?.customers?.full_name
                          ? 'Guest'
                          : ticketData?.result?.customers?.full_name}
                      </Title>
                    ) : (
                      <Title order={5}>
                        Name:{' '}
                        {!ticketData?.result?.guest_users?.first_name
                          ? 'Guest'
                          : ticketData?.result?.guest_users?.first_name}
                      </Title>
                    )}
                    <Group style={{ marginRight: '-50px' }}>
                      <Input.Label required>Mobile:</Input.Label>

                      {displayRefundMobile()}

                      <ActionIcon>
                        {!isMobileEdit ? (
                          <Edit size={48} strokeWidth={2} color="black" onClick={mobileEdit} />
                        ) : (
                          <EditOff size={48} onClick={mobileEdit} strokeWidth={2} color="black" />
                        )}
                      </ActionIcon>
                    </Group>
                  </Group>
                  {invoiceData?.invoice_status?.name === 'pending' ? (
                    <Group>
                      <Title order={5}>payment Info : </Title>
                      <Title order={5} color="red">
                        Pending
                      </Title>
                    </Group>
                  ) : null}

                  <Group px="xl">
                    <Button
                      leftIcon={<Image src={cashIcon} size={14} />}
                      style={{
                        width: '45%',
                      }}
                      disabled
                    >
                      Cash
                    </Button>
                    <Button
                      leftIcon={<Image src={cardIcon} size={14} />}
                      style={{ width: '45%' }}
                      disabled
                    >
                      Card
                    </Button>
                  </Group>

                  <Group>
                    <Title order={5}>Refund Amount : </Title>
                    <Input
                      value={
                        refundAmountWithTax > 0
                          ? refundAmountWithTax.toLocaleString('en-US', {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })
                          : 0
                      }
                      placeholder="Refund Amount"
                      onChange={onChangeInput}
                      disabled
                    />
                  </Group>
                  <Center>
                    <Button
                      style={{ width: '85%', backgroundColor: '#01AA84' }}
                      onClick={RefundAmountModal}
                      disabled={
                        refundAmountWithTax < 0.1 ||
                        invoiceData?.refunded_amount > 0 ||
                        invoiceData?.invoice_status?.name === 'pending'
                      }
                    >
                      Refund
                    </Button>
                  </Center>
                </Stack>
              </Paper>
            ) : (
              <Box>
                <Space h="xl" />
                <Space h="xl" />
                <Space h="xl" />
                {isLoading ? ( // Display loading state if isLoading is true
                  <Center>
                    <Stack>
                      <Center>
                        <Loader />
                      </Center>
                      <Center>
                        <Title>Loading...</Title>
                      </Center>
                    </Stack>
                  </Center>
                ) : (
                  <Center p="xl">
                    <Title>Enter Invoice Number & Date to get Invoice Details</Title>
                  </Center>
                )}
              </Box>
            )}
          </Box>

          <Modal
            opened={confirmRefund}
            centered
            onClose={() => setConfirmRefund(false)}
            title={
              <Text p="xl" className="no-printme">
                Confirm the Refund
              </Text>
            }
          >
            <Box>
              <Center>
                <Title order={1}>
                  Amount :{' '}
                  {refundAmountWithTax.toLocaleString('en-US', {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  })}{' '}
                  SAR
                </Title>
              </Center>
              <Center py="xl">
                <Button
                  style={{ width: '40%', backgroundColor: '#01AA84' }}
                  onClick={conirmRefundModel}
                >
                  <Text>Confirm</Text>
                </Button>
              </Center>
            </Box>
          </Modal>

          <Modal opened={verifyRefund} centered onClose={() => setVerifyRefund(false)}>
            <VerifyRefund
              refundAmount={refundAmountWithTax.toLocaleString('en-US', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })}
              selectedVas={selectedVas}
              refundInfo={refundInfo}
              customerMobile={
                isMobileEdit
                  ? getInputValue('mobileNumber')
                  : ticketData?.result?.customers?.mobile || ticketData?.result?.guest_users?.mobile
              }
              dailCode={dialCodeCustomer()}
              invoiceNumber={invoiceData?.id}
              passId={invoiceData?.reservations?.pass_id}
              profileData={profileData}
            />
          </Modal>
        </AppShell>
      </div>
    </LandingLayout>
  );
};

export default Refund;
